const formatConstructorItemStyle = (item) => {
  const { id, itemStyle } = item;
  return {
    [`--pa-${id}-constructor-item-background-color-inner`]: `var(--pa-${id}-constructor-item-background-color, ${(itemStyle == null ? void 0 : itemStyle.backgroundColor) ?? "transparent"})`,
    [`--pa-${id}-constructor-item-padding-top-inner`]: `var(--pa-${id}-constructor-item-padding-top, ${(itemStyle == null ? void 0 : itemStyle.paddingTop) ?? "0px"})`,
    [`--pa-${id}-constructor-item-padding-right-inner`]: `var(--pa-${id}-constructor-item-padding-right, ${(itemStyle == null ? void 0 : itemStyle.paddingRight) ?? "0px"})`,
    [`--pa-${id}-constructor-item-padding-bottom-inner`]: `var(--pa-${id}-constructor-item-padding-bottom, ${(itemStyle == null ? void 0 : itemStyle.paddingBottom) ?? "0px"})`,
    [`--pa-${id}-constructor-item-padding-left-inner`]: `var(--pa-${id}-constructor-item-padding-left, ${(itemStyle == null ? void 0 : itemStyle.paddingLeft) ?? "0px"})`,
    ...itemStyle,
    backgroundColor: `var(--pa-${id}-constructor-item-background-color-inner)`,
    paddingTop: `var(--pa-${id}-constructor-item-padding-top-inner)`,
    paddingRight: `var(--pa-${id}-constructor-item-padding-right-inner)`,
    paddingBottom: `var(--pa-${id}-constructor-item-padding-bottom-inner)`,
    paddingLeft: `var(--pa-${id}-constructor-item-padding-left-inner)`
  };
};
export {
  formatConstructorItemStyle
};
